import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, MessageCircle } from 'lucide-react';

const LNCTA = () => {
  return (
    <section
      className="ln-cta-section px-4 py-14 sm:px-6 lg:px-8"
      style={{ backgroundColor: '#F4F6FB' }}
    >
      <div
        className="mx-auto max-w-7xl overflow-hidden rounded-lg px-6 py-10 sm:px-10 lg:px-12"
        style={{
          background: 'linear-gradient(135deg, #173653 0%, #176F91 100%)',
          boxShadow: '0 24px 70px rgba(8, 37, 61, 0.18)',
        }}
      >
        <div className="grid gap-8 lg:grid-cols-[1fr_auto] lg:items-center">
          <div>
            <div
              className="mb-5 inline-flex items-center gap-2 rounded-lg border px-4 py-2 text-sm font-bold"
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.12)',
                borderColor: 'rgba(255, 255, 255, 0.22)',
                color: '#FFFFFF',
              }}
            >
              <MessageCircle className="h-4 w-4" style={{ color: '#78D7DC' }} />
              Start your Infor LN roadmap
            </div>

            <h2
              className="max-w-3xl text-2xl font-bold leading-tight tracking-tight sm:text-3xl md:text-4xl"
              style={{ color: '#FFFFFF' }}
            >
              Infor LN Consultation
            </h2>
            <p
              className="mt-5 max-w-2xl text-base leading-8 sm:text-lg"
              style={{ color: '#FFFFFF', fontWeight: 400 }}
            >
              Talk to PT KCS Tech about implementation, customization,
              integration, support, or optimization for your Infor LN
              environment.
            </p>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row lg:flex-col">
            <Link to="/contact" onClick={() => window.scrollTo(0, 0)}>
              <button
                className="inline-flex w-full items-center justify-center gap-3 rounded-lg px-6 py-4 text-base font-bold transition duration-300 hover:-translate-y-1"
                style={{
                  backgroundColor: '#FFFFFF',
                  color: '#0B1F32',
                  boxShadow: '0 18px 42px rgba(0, 0, 0, 0.18)',
                }}
              >
                  <Calendar className="h-5 w-5" style={{ color: '#1787A8' }} />
                Schedule a Meeting
              </button>
            </Link>

            <Link to="/contact" onClick={() => window.scrollTo(0, 0)}>
              <button
                className="inline-flex w-full items-center justify-center gap-3 rounded-lg border px-6 py-4 text-base font-bold transition duration-300 hover:-translate-y-1"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderColor: 'rgba(255, 255, 255, 0.25)',
                  color: '#FFFFFF',
                }}
              >
                Request Consultation
                <ArrowRight className="h-5 w-5" />
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LNCTA;
